import { Appear, Notes, Split, Image, Head } from "mdx-deck";
import { CodeSurfer, Step, CodeSurferColumns } from "code-surfer";
import QRCode from "qrcode.react";
import { github } from "@code-surfer/themes";
import "prismjs/components/prism-csharp";
import styled from "styled-components";
import { theme as customTheme } from "../../../../../../theme";
import Layout from "../../../../../../components/layout";
import BlockQuote from "../../../../../../components/blockquote";
import ListItem from "../../../../../../components/listitem";
import Onion from "../../../../../../components/onion";
import ebay from "!!file-loader!../../../../../../images/ebay.png";
import Cohesion from "../../../../../../components/cohesion";
import bookfound from "!!file-loader!../../../../../../images/TDD By Example by Kent Beck - BookFound.png";
import tdd from "!!file-loader!../../../../../../images/TDD-By-Example.jpg";
import tweet from "!!file-loader!../../../../../../images/kent-beck-tweet.png";
import Desiderata from "../../../../../../components/desiderata";
import React from 'react';
export default {
  Appear: Appear,
  Notes: Notes,
  Split: Split,
  Image: Image,
  Head: Head,
  CodeSurfer: CodeSurfer,
  Step: Step,
  CodeSurferColumns: CodeSurferColumns,
  QRCode: QRCode,
  github: github,
  styled: styled,
  customTheme: customTheme,
  Layout: Layout,
  BlockQuote: BlockQuote,
  ListItem: ListItem,
  Onion: Onion,
  ebay: ebay,
  Cohesion: Cohesion,
  bookfound: bookfound,
  tdd: tdd,
  tweet: tweet,
  Desiderata: Desiderata,
  React: React
};